import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=2e14d8ce&scoped=true&"
import script from "./Loader.vue?vue&type=script&lang=tsx&"
export * from "./Loader.vue?vue&type=script&lang=tsx&"
import style0 from "./Loader.vue?vue&type=style&index=0&id=2e14d8ce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e14d8ce",
  null
  
)

export default component.exports